<template lang="pug">
  shListData(title="Users History" resolver="usersHistory" keyData="_id" component="shUser" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'UsersHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/user/UsersHistory.vue